<template>
  <div>
    <div class="sac__font-18 med">
      Comfort Credits Balance
    </div>
    <fragment>
      <div v-if="!loadingComfortCredit" class="card">
        <div class="sac__font-50 basil semi-bold center">
          ${{ comfortCreditBalance }}
        </div>
        <div class="sac__font-16 med n60 center">
          so far towards next major repair
        </div>
      </div>
      <div
        v-else
        class="card loader"
      >
        <img
          src="@shared/assets/img/general/loading.svg"
          alt="Loader"
          class="img-size-24"
        >
      </div>
    </fragment>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ComfortCreditDetail',
  computed: {
    ...mapState({
      comfortCreditBalance: (state) => state.customerDetail.comfortCreditBalance,
      loadingComfortCredit: (state) => state.customerDetail.loadingComfortCredit,
    }),
  },
};
</script>
<style scoped lang="scss">
.card {
  border-radius: 8px;
  background-color: $N5;
  display: grid;
  align-items: center;
  margin-top: 1rem;
  min-height: 15rem;
  padding: 2rem;
  &.loader {
    justify-content: center;
    align-items: center;
  }
}
</style>
